/**
 * Element colour ramps for the skill-FX detail layer (C0-SKILLFX, docs/research/C0_VFX.md §10): five tones from
 * dark to light, hue-shifted (darks cooler and more saturated, lights paler and warmer), so a particle keeps a dark
 * outline on bright grass and a pale head on dark stone. Index 0 outlines, 2 is the body, 4 the spark head / smear.
 */
export type RampId = 'wind' | 'leaf' | 'cloud' | 'mist' | 'blood' | 'ink' | 'dust';
export type Ramp = readonly [string, string, string, string, string];

export const RAMPS: Readonly<Record<RampId, Ramp>> = {
  // กระบี่ไผ่ห่มหมอก: jade wind and bamboo green.
  wind: ['#173a3a', '#2a6e62', '#4fae8e', '#9fe3c2', '#f2fff0'],
  // Young bamboo: a deep outline and a bright yellow-green body, so a leaf stands off the grass.
  leaf: ['#0e2410', '#2c6a2a', '#86d24a', '#d0f28a', '#fbffe4'],
  // ฝ่ามือเมฆาคล้อย: pearl cloud with a lavender shade; mist cooler and paler.
  cloud: ['#34365a', '#5f6496', '#9aa2cf', '#d6dcf4', '#ffffff'],
  mist: ['#3a4a5a', '#64788a', '#9ab0bf', '#cfdde4', '#f4fbff'],
  // ดาบชาด: crimson to a warm pale head.
  blood: ['#2e0306', '#6e0a14', '#b81626', '#f04a3a', '#ffc2a0'],
  // หอหมึกสน: sumi ink to paper white.
  // (C0-VFX-PREP: sumi black is gone with the ink look; the brush art's qi is indigo light, paper-white head.)
  ink: ['#14122e', '#2a2650', '#6a64a8', '#b8b4ec', '#fbf8ff'],
  // Ground scuffs and dust.
  dust: ['#4a3a28', '#7a6248', '#a8865a', '#d2b88a', '#efe2c4'],
};
